import { useState, useEffect, useCallback } from "react";

import styles from "./stylesTableTabs.module.css";
import { AppStrings } from "../../../../utils/constants/AppStrings";

function TableTabs({ onSelectTab }) {
  const [activeTab, setActiveTab] = useState();

  const handleTabClick = useCallback(
    (id) => {
      setActiveTab(id);
      onSelectTab(id);
    },
    [onSelectTab],
  );

  useEffect(() => {
    handleTabClick("PENDING");
  }, [handleTabClick]);

  return (
    <div className={styles.tableTabs}>
      <div
        onClick={() => handleTabClick("PENDING")}
        className={`${styles.tableTab} ${
          activeTab === "PENDING" ? styles.active : ""
        }`}
      >
        <span>{AppStrings.PENDING_TAB}</span>
      </div>
      <div
        onClick={() => handleTabClick("IN_PROGRESS")}
        className={`${styles.tableTab} ${
          activeTab === "IN_PROGRESS" ? styles.active : ""
        }`}
      >
        <span>{AppStrings.IN_PROGRESS}</span>
      </div>
      <div
        onClick={() => handleTabClick("PROCESSED")}
        className={`${styles.tableTab} ${
          activeTab === "PROCESSED" ? styles.active : ""
        }`}
      >
        <span>{AppStrings.PROCESSED_TAB}</span>
      </div>
    </div>
  );
}

export default TableTabs;
